var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonagemIndicacao = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 148,
  height: 121,
  viewBox: "0 0 148 121",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 11.401L12.4603 106.589C13.1588 114.807 18.2994 119.923 26.8204 120.706L125.553 116.932C134.074 117.687 141.59 112.599 142.204 105.61L147.959 38.2939C148.574 31.3051 142.12 24.9593 133.599 24.1765L16.651 0.0791214C8.12995 -0.703626 0.614635 4.41218 0 11.401Z",
  fill: "url(#paint0_linear_20693_16988)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.5476 97.5032V84.4481C58.7817 85.5663 55.513 85.3706 52.9147 83.9169C52.356 83.6094 51.8251 83.218 51.3223 82.7987C48.9755 80.758 47.7183 77.7109 47.7183 74.5799V41.0615C49.3387 33.5695 54.6748 29.9633 61.7711 27.0559C68.8673 24.1486 77.0531 24.4281 84.2052 27.1678C88.8988 28.9569 93.313 31.8642 96.0509 36.0855C99.5153 41.4249 99.5711 49.6438 99.0403 55.766C98.5933 60.9097 97.0288 66.0535 93.9277 70.1909V94.1206L61.5476 97.5032Z",
  fill: "#8B5624"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.9697 57.1078C45.2039 57.3035 42.4101 55.9057 40.9014 53.5854C39.3928 51.2651 39.281 48.1062 40.6221 45.7021C40.8176 45.3107 41.0691 44.9193 41.0691 44.5C41.0691 44.1366 40.8735 43.7731 40.6779 43.4377C38.2194 38.8251 38.7223 32.7867 41.9351 28.6494C45.148 24.512 50.8473 22.4992 55.9321 23.7292C59.4802 19.2005 65.3751 16.6286 71.1024 17.1597C76.8297 17.6909 82.1658 21.2971 84.8199 26.4129C89.3459 24.9872 94.6262 26.357 97.9228 29.7955C101.192 33.234 102.337 38.5735 100.689 43.0463C101.024 42.1238 105.271 47.8826 105.494 48.3019C106.947 50.9576 107.506 53.9768 106.947 56.968C106.22 60.9097 103.818 64.4321 100.745 67.004C97.6714 69.5758 93.9556 71.3091 90.1561 72.567L89.9605 72.5111C88.7312 73.1541 87.8372 71.3929 87.8372 70.0231C87.8372 68.6533 88.7033 67.4512 89.4576 66.2771C91.1618 63.6214 92.3073 60.6581 92.8661 57.5551C93.2293 55.4864 93.1175 52.9145 91.3015 51.8802C89.8767 51.0415 87.9769 51.6006 86.6918 52.607C85.3228 53.6693 84.345 55.2348 84.0097 56.9401C83.7024 58.4217 83.5627 60.3786 82.082 60.7699C78.3942 61.6925 78.4501 52.8306 78.2824 50.8738C78.0031 47.8267 77.7237 44.7516 77.4722 41.7045C74.3152 44.5838 69.7055 46.373 65.431 46.6525C63.8664 46.7644 62.3019 46.6525 60.7374 46.5687C59.2287 46.4848 57.7201 46.4009 56.2114 46.4848C53.1383 46.6525 49.8695 47.7428 48.2212 50.3147C48.5285 52.607 48.3609 54.9273 47.9418 57.2196C47.9418 57.1357 47.9418 57.1637 47.9418 57.1637C47.9697 57.1637 47.9697 57.1917 47.9697 57.1078Z",
  fill: "#191919"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M69.6494 54.8443C69.6494 55.655 68.9789 56.3259 68.1687 56.3259C67.3585 56.3259 66.688 55.655 66.688 54.8443C66.688 54.0336 67.3585 53.3627 68.1687 53.3627C68.9789 53.3347 69.6494 54.0056 69.6494 54.8443Z",
  fill: "#191919"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M60.8764 52.9707C60.597 52.9707 60.3455 53.1105 60.2338 53.4459C59.3957 56.2974 58.4178 59.1488 57.6914 62.0282C56.993 64.7958 59.0604 65.1033 61.1278 65.1033C61.7145 65.1033 62.3291 65.0753 62.86 65.0753C63.726 65.0753 63.726 63.7055 62.86 63.7055C62.3291 63.7055 61.3234 63.8733 60.4852 63.8733C60.0662 63.8733 59.703 63.8453 59.4795 63.7055C58.334 63.0905 59.3118 61.3573 59.5633 60.4907C60.2338 58.2542 60.8764 56.0178 61.5469 53.8094C61.7145 53.3062 61.2954 52.9707 60.8764 52.9707Z",
  fill: "#4C1D05"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M49.8135 54.8154C49.9811 54.9272 50.1767 54.9831 50.3723 54.9272C51.9089 54.5079 54.0042 54.5918 55.4011 55.5143C55.7643 55.7659 56.0716 56.0454 56.3231 56.4089C56.3789 56.4927 56.4628 56.5486 56.5186 56.6045C56.9936 56.94 57.7479 56.5486 57.3568 55.9895C56.9656 55.4025 56.4907 54.9552 55.9319 54.5918C54.116 53.3897 51.6854 53.3897 49.7576 53.8929C49.2827 54.0047 49.4503 54.5638 49.8135 54.8154Z",
  fill: "#191919"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M61.5476 84.4478C61.4917 84.4757 61.4078 84.5037 61.3518 84.5316L61.5476 86.796V84.4478Z",
  fill: "url(#paint1_linear_20693_16988)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M72.5549 79.8643L61.3518 84.421V84.5328C61.4077 84.5048 61.4915 84.4769 61.5474 84.4489V86.7972L61.8826 90.7948H62.4693L72.5549 79.8643Z",
  fill: "#4C1D05"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M62.4976 90.7939H61.9109L61.9668 91.381L62.4976 90.7939Z",
  fill: "#5E161E"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M60.4578 70.6943C60.4578 70.6943 64.425 70.275 67.8334 67.7031C67.8334 67.7031 69.4817 74.4963 61.5194 75.5586L60.4578 70.6943Z",
  fill: "white"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M67.2187 66.7241C67.0232 66.7241 66.7997 66.808 66.632 67.0037C65.4866 68.5133 63.503 69.911 61.6591 69.911C61.1841 69.911 60.7371 69.8272 60.2901 69.6035C60.1784 69.5476 60.0945 69.5196 59.9828 69.5196C59.3402 69.5196 58.9212 70.4422 59.5917 70.7776C60.3181 71.1131 61.0165 71.2529 61.7429 71.2529C64.1456 71.2529 66.3527 69.5476 67.8054 67.6466C68.1966 67.2273 67.7216 66.7241 67.2187 66.7241Z",
  fill: "#4C1D05"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_20693_16988",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 148,
  height: 121
}, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M0 11.401L12.4603 106.589C13.1588 114.807 18.2994 119.923 26.8204 120.706L125.553 116.932C134.074 117.687 141.59 112.599 142.204 105.61L147.959 38.2939C148.574 31.3051 142.12 24.9593 133.599 24.1765L16.651 0.0791214C8.12995 -0.703626 0.614635 4.41218 0 11.401Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_20693_16988)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M161.286 130.575L133.655 98.4827C128.906 92.7239 121.586 89.9843 114.378 91.0186L114.35 90.795H46.07C45.9303 90.795 45.8185 90.9068 45.7906 91.0466C38.7781 89.7047 31.4305 92.1089 26.3737 97.672L-0.642334 123.335L14.975 135.831C25.8149 145.28 21.736 142.959 29.5586 153.023L40.3147 137.396L38.834 150.172L35.0903 182.013H123.291L120.832 145.364L125.134 152.912L161.286 130.575Z",
  fill: "#AC41D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.134 152.911L161.286 130.575L131.364 95.9942C131.364 95.9942 126.335 90.3192 114.378 91.0181C114.378 91.0181 94.8771 99.9638 107.589 122.244L125.134 152.911Z",
  fill: "url(#paint2_linear_20693_16988)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-0.67041 123.195L29.5864 153.023L56.0995 115.731C56.0995 115.731 60.4299 109.469 56.9097 98.0353C56.9097 98.0353 43.5833 81.2342 25.0046 98.8739L-0.67041 123.195Z",
  fill: "url(#paint3_linear_20693_16988)"
}))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.8388 54.7481L38.6095 58.3543L36.3762 57.593L37.6055 53.9868L39.8388 54.7481Z",
  fill: "white"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.2385 42.4634L42.4903 38.6895L44.8445 38.8465L44.5928 42.6205L42.2385 42.4634Z",
  fill: "white"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.8896 44.3936L35.1575 41.011L37.2576 39.9355L38.9897 43.3181L36.8896 44.3936Z",
  fill: "white"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.9057 50.9382L31.1899 51.693L30.7202 49.3808L34.436 48.626L34.9057 50.9382Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20693_16988",
  x1: -0.000530821,
  y1: 60.3507,
  x2: 148.015,
  y2: 60.3507,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E97903"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0739316,
  stopColor: "#EC8709"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2075,
  stopColor: "#EF9910"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3662,
  stopColor: "#F2A616"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5723,
  stopColor: "#F4AE19"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4B01A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_20693_16988",
  x1: -45.4563,
  y1: 270.817,
  x2: 114.104,
  y2: -5.72268,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#781601"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.00466358,
  stopColor: "#781601"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1982,
  stopColor: "#7C1F03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5491,
  stopColor: "#802904"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#812C05"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_20693_16988",
  x1: 136.674,
  y1: 150.474,
  x2: 127.716,
  y2: 88.4262,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7411B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AC41D8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_20693_16988",
  x1: 4.48657,
  y1: 133.85,
  x2: 62.6015,
  y2: 110.43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7411B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AC41D8"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonagemIndicacao);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/personagem-indicacao.e0e910f3d187adb95b9f236cb6f9ba8d.svg";